import React from 'react';
import { comparisonRows } from '../data/content';
export function Comparison() {
  return <section className="border-b border-line bg-ink py-16 md:py-24" aria-labelledby="comparison-title" data-id="element-30" data-mp="1g7t2qvwm576j">
      <div className="mx-auto max-w-5xl px-5 md:px-8" data-id="element-31" data-mp="1l6w0rwe6ed50">
        <h2 id="comparison-title" className="font-display text-4xl font-extrabold uppercase text-white md:text-6xl" data-id="element-32" data-mp="1l5b4o2c7qm51">
          Without vs. With Baseball 360
        </h2>

        <div className="mt-10 overflow-x-auto rounded-xl border border-line" data-id="element-33" data-mp="1uzbeuimcqhkm">
          <table className="w-full min-w-[620px] border-collapse text-left" data-id="element-34" data-mp="1zuqrx8cjc9fz">
            <thead data-id="element-35" data-mp="23yykjgm469jh">
              <tr className="bg-ink-700" data-id="element-36" data-mp="23yez3px9930p">
                <th scope="col" className="px-5 py-4 text-sm font-semibold text-slate-400" data-id="element-37" data-mp="28wq9q2vdjhjz">
                  <span className="sr-only" data-id="element-38" data-mp="9jvyjsw9x9lb">Area</span>
                </th>
                <th scope="col" className="px-5 py-4 font-display text-lg font-bold uppercase tracking-wide text-slate-300" data-id="element-39" data-mp="9lyx51bhsb1n">
                  ❌ Without Baseball 360
                </th>
                <th scope="col" className="px-5 py-4 font-display text-lg font-bold uppercase tracking-wide text-emerald-400" data-id="element-40" data-mp="1h9h2pezmnu1u">
                  ✅ With Baseball 360
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-line" data-id="element-41" data-mp="187hmgowfstzy">
              {comparisonRows.map(row => <tr key={row.label} className="bg-ink-800" data-id="element-42" data-mp="20xzxcc3ejznx">
                  <th scope="row" className="px-5 py-4 text-sm font-semibold text-white md:text-base" data-id="element-43" data-mp="20yhqv0yojzs5">
                    {row.label}
                  </th>
                  <td className="px-5 py-4 text-sm text-slate-400 md:text-base" data-id="element-44" data-mp="1r1wkab70igm7">{row.without}</td>
                  <td className="px-5 py-4 text-sm font-semibold text-white md:text-base" data-id="element-45" data-mp="khn822wgyxdl">
                    {row.with}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}